function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHealth = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.539,6.152L24.524,6.527L29.649,6.527C33.789,6.527 37.148,9.887 37.148,14.027C37.148,18.167 33.789,21.527 29.649,21.527L26.524,21.527L26.524,15.277L29.649,15.277C30.336,15.277 30.899,14.714 30.899,14.027C30.899,13.339 30.336,12.777 29.649,12.777L24.336,12.777L23.985,24.027L27.149,24.027C31.289,24.027 34.648,27.386 34.648,31.526C34.648,35.667 31.289,39.026 27.149,39.026L25.899,39.026L25.899,32.776L27.149,32.776C27.836,32.776 28.399,32.214 28.399,31.526C28.399,30.839 27.836,30.276 27.149,30.276L23.789,30.276L23.547,38.049L23.438,41.448L23.438,41.526C23.414,42.221 22.844,42.776 22.149,42.776C21.454,42.776 20.883,42.221 20.86,41.526L20.86,41.448L20.782,39.026L17.774,39.026C16.048,39.026 14.649,37.628 14.649,35.901C14.649,34.175 16.048,32.776 17.774,32.776L20.586,32.776L20.508,30.276L19.024,30.276C14.884,30.276 11.524,26.917 11.524,22.777C11.524,19.058 14.227,15.972 17.774,15.378L17.774,22.777C17.774,23.464 18.336,24.027 19.024,24.027L20.313,24.027L19.961,12.777L16.727,12.777C16.024,14.254 14.516,15.277 12.774,15.277L11.524,15.277C9.11,15.277 7.149,13.316 7.149,10.902C7.149,8.488 9.11,6.527 11.524,6.527L19.766,6.527L19.758,6.152L19.727,5.277L19.727,5.129C19.766,3.832 20.829,2.785 22.149,2.785C23.469,2.785 24.532,3.832 24.571,5.129L24.571,5.277L24.539,6.152ZM12.149,11.527C12.837,11.527 13.399,10.965 13.399,10.277C13.399,9.59 12.837,9.027 12.149,9.027C11.462,9.027 10.899,9.59 10.899,10.277C10.899,10.965 11.462,11.527 12.149,11.527Z",
    style: {
      fill: "#00659d",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.149,
    y: 0.781,
    width: 44,
    height: 44,
    style: {
      fill: "none"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHealth);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/health.bf98820afa8bbe1e3ea9ca5524613ac3.svg";